import * as actions from '../actions/TaskStatusPanelActions';

const initialTaskStatusPanelState = {
  loading: true,
  error: null,
  start: null,
  disabled: false,
  tasks: [],
};

const taskStatusPanelReducer = (state = initialTaskStatusPanelState, action) => {
  switch (action.type) {
    case actions.TASK_STATUS_PANEL_GET_TASK_STATUS:
      return initialTaskStatusPanelState;
    case actions.TASK_STATUS_PANEL_GET_TASK_STATUS_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        loading: false,
        start: payload.taskStatus.start,
        tasks: payload.taskStatus.tasks || [],
        disabled: payload.taskStatus.disableViewTaskStatus,
      };
    }
    case actions.TASK_STATUS_PANEL_GET_TASK_STATUS_FAILURE: {
      const { payload } = action;
      return {
        ...state,
        loading: false,
        error: payload.error,
      };
    }
    default:
      return state;
  }
};

export default taskStatusPanelReducer;
